import {
    Box,
    Typography,
    Link as MuiLink,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import { GitHub, Article, Language, ExpandMore } from '@mui/icons-material';

export const AdvanceML = () => {
    const topics = [
        {
            title: "06 Principal Component Analysis — PCA",
            videoId: "Zyo9lTvhAxk",
            mediumLink: "https://kmeeraj.medium.com",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/aaarXiwDnyk?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/oXFQ8fBKRkg?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "09 - Eigenface",
            videoId: "120k1UVuZHI",
            mediumLink: "https://kmeeraj.medium.com/09-eigenface-47e3e0799aef",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/lsWokby_Pk0?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/SDhX8yeLprE?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "10 - Perceptron",
            videoId: "X2ZLk8v42VE",
            mediumLink: "https://kmeeraj.medium.com/10-perceptron-algorithm-demo-77fef075f395",
            githubLink: "https://github.com/kmeeraj/machinelearning/blob/develop/algorithms/Perceptron%20Gradient%20Descent.ipynb",
            hindiLink: "https://youtu.be/YSrpImyzFQ8?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/SDhX8yeLprE?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "11 - Mean Square Error Gradient Descent",
            videoId: "N_9Ki-gyuQ4",
            mediumLink: "https://kmeeraj.medium.com/11-mean-square-error-gradient-descent-ae9bdb33548f",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/m7bouq6hpcM?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/VriwslWiAX0?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "14 - Logistic Regression",
            videoId: "9pP2yK4t__Q",
            mediumLink: "https://kmeeraj.medium.com/14-logistic-regression-8df305b5a28e",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/T02N5DDRxIQ?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/5_aHGm7f69c?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "15 - K Nearest Neighbour",
            videoId: "Z5HH89JYcR0",
            mediumLink: "https://kmeeraj.medium.com/k-nearest-neighbour-431e0996a268",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/h73ROkVP-WU?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/P4v4yGA76BQ?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        },
        {
            title: "16 - Maximum Likelihood Estimation",
            videoId: "Uh9351UKFMY",
            mediumLink: "https://medium.com/swlh/16-mle-maximum-likelihood-estimation-354a0612c0ea",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/N9dbaT3khr0?list=PL01e4bnNRw-Rx9paxRUOheI2X8tIf7nJ5",
            teluguLink: "https://youtu.be/8p1ZifadpbY?list=PL01e4bnNRw-RNqeHoBLtH9OChDwMy3t3X"
        }
    ];

    return(
        <Box>
            <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
                Advance Machine Learning
            </Typography>
            
            {topics.map((topic, index) => (
                <Accordion key={index} sx={{ mb: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant="h6">{topic.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <iframe 
                                width="100%" 
                                height="300"
                                src={`https://www.youtube.com/embed/${topic.videoId}?list=PL01e4bnNRw-SZvEaIxSOo44Ip4ZPzLYvh`}
                                title="YouTube video player" 
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                            <Chip
                                icon={<Article />}
                                label="Medium Article"
                                component={MuiLink}
                                href={topic.mediumLink}
                                target="_blank"
                                clickable
                                color="primary"
                            />
                            <Chip
                                icon={<GitHub />}
                                label="GitHub"
                                component={MuiLink}
                                href={topic.githubLink}
                                target="_blank"
                                clickable
                                color="secondary"
                            />
                            <Chip
                                icon={<Language />}
                                label="Hindi"
                                component={MuiLink}
                                href={topic.hindiLink}
                                target="_blank"
                                clickable
                                color="success"
                            />
                            <Chip
                                icon={<Language />}
                                label="Telugu"
                                component={MuiLink}
                                href={topic.teluguLink}
                                target="_blank"
                                clickable
                                color="warning"
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    )
}